"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9703],{

/***/ 59703:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ Slider_Slider; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-multi-carousel/index.js
var react_multi_carousel = __webpack_require__(86529);
;// CONCATENATED MODULE: ./src/blocks/Slider/CustomDot.tsx


const CustomDot = (param)=>{
    let { onClick , active  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        onClick: (e)=>{
            if (onClick) {
                onClick();
            }
            e.preventDefault();
        },
        className: active ? "custom-dot custom-dot--active" : "custom-dot",
        children: "•"
    });
};
/* harmony default export */ var Slider_CustomDot = (CustomDot);

// EXTERNAL MODULE: ./src/components/Arrows/Chevron.tsx
var Chevron = __webpack_require__(2933);
;// CONCATENATED MODULE: ./src/blocks/Slider/ButtonGroup.tsx



const ButtonGroup = (props)=>{
    const { next , previous , carouselState  } = props;
    var _carouselState_currentSlide;
    const currentSlide = (_carouselState_currentSlide = carouselState === null || carouselState === void 0 ? void 0 : carouselState.currentSlide) !== null && _carouselState_currentSlide !== void 0 ? _carouselState_currentSlide : 0;
    var _carouselState_slidesToShow;
    const slidesToShow = (_carouselState_slidesToShow = carouselState === null || carouselState === void 0 ? void 0 : carouselState.slidesToShow) !== null && _carouselState_slidesToShow !== void 0 ? _carouselState_slidesToShow : 0;
    var _carouselState_totalItems;
    const totalItems = (_carouselState_totalItems = carouselState === null || carouselState === void 0 ? void 0 : carouselState.totalItems) !== null && _carouselState_totalItems !== void 0 ? _carouselState_totalItems : 0;
    const shouldShowNextButton = totalItems > currentSlide + slidesToShow;
    const shouldShowPrevButton = currentSlide !== 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "slider__buttonsGroup",
        children: [
            shouldShowPrevButton && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                "aria-label": "Previous package",
                className: "slider__buttonsGroup--left",
                onClick: ()=>previous && previous(),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chevron/* default */.Z, {})
            }),
            shouldShowNextButton && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                "aria-label": "Next package",
                className: "slider__buttonsGroup--right",
                onClick: ()=>next && next(),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chevron/* default */.Z, {})
            })
        ]
    });
};
/* harmony default export */ var Slider_ButtonGroup = (ButtonGroup);

;// CONCATENATED MODULE: ./src/blocks/Slider/Slider.tsx





const Slider = (param)=>{
    let { blockData  } = param;
    const { data: dataArray  } = blockData;
    const [data] = dataArray;
    const responsive = {
        all: {
            breakpoint: {
                max: 8000,
                min: 0
            },
            items: 1
        }
    };
    const { title , subheader , background , layout , element  } = data;
    const slides = Object.values(element);
    const getLayoutClass = ()=>{
        switch(layout){
            case "left":
                return "sliderContainer__layout--left";
            case "right":
                return "sliderContainer__layout--right";
            default:
                return "sliderContainer__layout--right";
        }
    };
    const getBackgroundStyle = ()=>{
        switch(background){
            case "yellow":
                return {
                    backgroundImage: "Url(/blocks/Slider/sliderBackground.png)",
                    backgroundColor: "#f7b52f"
                };
            case "violet":
                return {
                    backgroundImage: "Url(/blocks/Slider/sliderBackgroundViolet.jpg)",
                    backgroundColor: "#8f89e0",
                    backgroundSize: "contain"
                };
            default:
                return {
                    backgroundImage: "none",
                    backgroundColor: "initial"
                };
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "slider",
        style: getBackgroundStyle(),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "desktop-container sliderContainer ".concat(getLayoutClass()),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "sliderContainer__title",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            children: title
                        }),
                        subheader && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "sliderContainer__subtitle",
                            children: subheader
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "sliderContainer__slides",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_multi_carousel["default"], {
                        swipeable: true,
                        draggable: true,
                        arrows: false,
                        showDots: true,
                        renderDotsOutside: true,
                        responsive: responsive,
                        renderButtonGroupOutside: true,
                        customDot: /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider_CustomDot, {}),
                        customButtonGroup: /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider_ButtonGroup, {}),
                        children: slides.map((param, index)=>{
                            let { css , html_content  } = param;
                            const html = css ? "<style>".concat(css, "</style> ").concat(html_content) : html_content;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "slider__singleSlide",
                                dangerouslySetInnerHTML: {
                                    __html: html
                                }
                            }, "content-".concat(index));
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Slider_Slider = (Slider);

;// CONCATENATED MODULE: ./src/blocks/Slider/index.tsx



/***/ }),

/***/ 2933:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


const Chevron = (param)=>{
    let { style  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        version: "1.1",
        id: "Layer_1",
        x: "0px",
        y: "0px",
        viewBox: "0 0 512 512",
        style: style,
        xmlSpace: "preserve",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M339.9,10.7L120.4,230.1c-6.8,6.8-10.7,16.2-10.7,25.9c0,9.6,3.9,19,10.7,25.9l219.4,219.4c14.3,14.3,37.4,14.3,51.7,0 c14.3-14.3,14.3-37.4,0-51.7L198,256L391.6,62.4c14.3-14.3,14.3-37.4,0-51.7C377.3-3.6,354.1-3.6,339.9,10.7L339.9,10.7z"
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Chevron);


/***/ })

}]);